import { render, staticRenderFns } from "./AresLoading.vue?vue&type=template&id=00a8ee2e&"
import script from "~/themes/base/components/cart/AresLoading/AresLoading.js?vue&type=script&lang=js&"
export * from "~/themes/base/components/cart/AresLoading/AresLoading.js?vue&type=script&lang=js&"
import style0 from "~/themes/base/components/cart/AresLoading/AresLoading.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/themes/base/components/cart/AresLoading/AresLoading.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Foknadverenamiru%2Fcomponents%2Fcart%2FAresLoading%2FAresLoading.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports